/* @flow */
import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

import s from './UploadModal.styl';
const cx = classnames.bind(s);
import { Dropzone } from './Dropzone.js';
import { Spinner } from './Spinner.js';
import { mbToBytes } from '../utils/utils.js';
import {Button, IconButton, IconButtonPure} from 'trustar-2.0/components/Button';
import ButtonGroup from 'trustar-2.0/components/Button/ButtonGroup';
import {Icon, IconLookup} from 'trustar-2.0/components';
/**
 * NOTE: we do not currently implement the 'accept' attribute because it was
 * causing issues on drag. See: https://github.com/paramaggarwal/react-dropzone/issues/57
 */

// NOTE: closePortal is required and it is supplied by the Portal component.
// However for some reason prop types does not detect it so we get a prop
// types warning if we define it as required
//
type Props = {
  status: string,
  children?: any,
  closePortal?: Function,
  handleDropzoneError?: (a: File[], e: Event) => void,
  onDropAccepted: (a: File[], e: Event) => void,
};

const StyledModalContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 999;
`;

const StyledModalContent = styled.div`
  position: absolute;
  top: 50%; // Looks better when it tends toward the top, where content is
  left: 50%;
  width: 100%;
  max-width: 900px;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
  padding: 1.67rem;
  border: 1px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
  box-shadow: 0px 2px 40px 0px rgba(0,0,0,0.30);
  border-radius: 3px;
  z-index: 1000;
`;

const StyledButton = styled(Button)`
  && {
    margin-top: 1.67rem;
    background-color: ${({ theme }) => theme.ThemeColors.SURFACE_LIGHTER.hex};
  }
`;

export class UploadModal extends React.Component {
  props: Props;

  /**
   * After uploading completes we want to close the portal.
   */
  componentDidUpdate() {
    if (this.props.status === 'UPLOADING') return;

    if (this.props.closePortal) {
      this.props.closePortal();
    }
  }

  handleCloseModal = (e: Event) => {
    e.stopPropagation();

    if (this.props.closePortal) {
      this.props.closePortal();
    }
  };

  render() {
    return (
      <StyledModalContainer onClick={this.props.closePortal}>
        <StyledModalContent onClick={e => e.stopPropagation()}>
          <div className={cx(s.ModalChildren)}>
            {this.props.children}
          </div>
          <Dropzone
            className={cx(s.importDropzone, {
              [s.disabled]: this.props.status !== 'READY',
            })}
            maxSize={mbToBytes(2)}
            accept='.json,.csv'
            acceptedFileFormatMessage='Accepted file formats: .json,.csv'
            onDropRejected={this.props.handleDropzoneError}
            onDropAccepted={this.props.onDropAccepted} />

          {/* NOTE: Simply passing props.closePortal to the on click function
            * was throwing an error, assumedly because a parent handler also
            * has the stop propagation call.
            */}
          <StyledButton
            fill={'none'}
            onClick={this.handleCloseModal}
            >
            Close
          </StyledButton>
          {(this.props.status !== 'READY') && <Spinner className={s.inline} />}
        </StyledModalContent>
      </StyledModalContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/UploadModal.js